@if (theme === "tngh") {
  <lib-login-form
    [loginError]="loginError"
    (loginRequest)="doLogin($event)"
    (passwordResetRequest)="navigateToPasswordReset()"
  />
} @else {
  <mdef-login-form
    [loginError]="loginError"
    (loginRequest)="doLogin($event)"
    (passwordResetRequest)="navigateToPasswordReset()"
  />
}
